import { Flex } from 'rebass';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Card, Space, Tooltip } from 'antd';
import styled from 'styled-components';
import { width } from 'styled-system';

const StyledCard = styled(Card)`
  ${width}
`;

function FormGroupTitle({ tooltip, label }) {
  return (
    <Space align="center">
      {label}
      {tooltip && (
        <Tooltip placement="bottom" title={tooltip}>
          <Flex alignItems="center">
            <QuestionCircleOutlined />
          </Flex>
        </Tooltip>
      )}
    </Space>
  );
}

FormGroupTitle.propTypes = {
  tooltip: PropTypes.string,
  label: PropTypes.string,
};

export function FormGroup({ label, tooltip, extra, columns, children, ...props }) {
  const width = useMemo(() => {
    const columnsArray = Array.isArray(columns) ? columns : [columns];
    return columnsArray?.map(column => 1 / column);
  }, [columns]);

  return (
    <StyledCard title={label && <FormGroupTitle label={label} tooltip={tooltip} />} extra={extra} w={1} {...props}>
      <Flex flexWrap="wrap" mx={-2} className="card-body-inner">
        {React.Children.map(children, child => child && React.cloneElement(child, columns ? { width } : null))}
      </Flex>
    </StyledCard>
  );
}

FormGroup.propTypes = {
  extra: PropTypes.node,
  tooltip: PropTypes.string,
  label: PropTypes.string,
  columns: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
  children: PropTypes.node.isRequired,
};
